import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpenIcon, CalendarIcon, ShoppingCartIcon, WindIcon, CoffeeIcon } from 'lucide-react';
export function DeliverablesSection() {
  const deliverables = [{
    icon: <BookOpenIcon className="w-8 h-8 text-[#4A6741]" data-id="element-22" />,
    title: 'La Guía Maestra "Vientre Plano 50+"',
    desc: '(PDF de lectura rápida)'
  }, {
    icon: <CalendarIcon className="w-8 h-8 text-[#4A6741]" data-id="element-23" />,
    title: 'El Protocolo de Reseteo de 7 Días',
    desc: '(Paso a paso diario)'
  }, {
    icon: <ShoppingCartIcon className="w-8 h-8 text-[#4A6741]" data-id="element-24" />,
    title: 'Lista de la Compra Anti-Inflamación',
    desc: '(Para el súper en España)'
  }, {
    icon: <WindIcon className="w-8 h-8 text-[#4A6741]" data-id="element-25" />,
    title: 'El Ritual de 5 Minutos',
    desc: 'para bajar el Cortisol'
  }, {
    icon: <CoffeeIcon className="w-8 h-8 text-[#4A6741]" data-id="element-26" />,
    title: 'Guía de Infusiones "Efecto Drenante"',
    desc: 'para después de cenar'
  }];
  return <section className="py-20 bg-[#FAF7F2]" data-id="element-27">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-28">
        <FadeIn data-id="element-29">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2A26] text-center mb-16" data-id="element-30">
            Lo que vas a recibir hoy:
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-31">
          {deliverables.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={index === 3 ? 'lg:col-start-1 lg:col-end-2 lg:translate-x-1/2' : index === 4 ? 'lg:col-start-2 lg:col-end-3 lg:translate-x-1/2' : ''} data-id="element-32">
              <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 h-full flex flex-col items-center text-center border border-[#E8EDE6] group" data-id="element-33">
                <div className="p-4 bg-[#E8EDE6] rounded-full mb-6 group-hover:bg-[#4A6741] group-hover:text-white transition-colors duration-300" data-id="element-34">
                  {/* Clone element to override color on hover if needed, but CSS handles it better. We'll just let the icon inherit or keep its color. Actually, let's make the icon color inherit. */}
                  <div className="text-[#4A6741] group-hover:text-white transition-colors duration-300" data-id="element-35">
                    {item.icon}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-[#2D2A26] mb-2 font-serif" data-id="element-36">
                  {item.title}
                </h3>
                <p className="text-[#6B6560]" data-id="element-37">{item.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}